import { RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { formatOrganizationDate } from "../api/organizations.api";
import type { Organization } from "../types/organization.types";
import { OrganizationStatusBadge } from "./OrganizationStatusBadge";

interface OrganizationsTableProps {
	organizations: Organization[];
	onOpenOrganization: (organization: Organization) => void;
}

export function OrganizationsTable({ organizations, onOpenOrganization }: OrganizationsTableProps) {
	return (
		<div className="crm-card crm-table-card crm-organizations-table-card">
			<div className="crm-table-wrap">
				<table className="crm-table">
					<thead>
						<tr>
							<th>Tashkilot</th>
							<th>Kod</th>
							<th>Telefon</th>
							<th>Binolar</th>
							<th>Aktiv sotuv</th>
							<th>Mijoz</th>
							<th>Holat</th>
							<th aria-label="Actions" />
						</tr>
					</thead>
					<tbody>
						{organizations.map((organization) => (
							<tr key={organization.id} onClick={() => onOpenOrganization(organization)}>
								<td data-label="Tashkilot">
									<div className="crm-org-name-cell">
										<span className={`crm-mini-avatar ${organization.tone}`}>
											{organization.initials}
										</span>
										<div>
											<strong>{organization.name}</strong>
											<span>{formatOrganizationDate(organization.createdAt)}</span>
										</div>
									</div>
								</td>
								<td data-label="Kod">{organization.code}</td>
								<td data-label="Telefon">{organization.phone}</td>
								<td data-label="Binolar">{organization.buildingsCount}</td>
								<td data-label="Aktiv sotuv">{organization.activeSalesCount}</td>
								<td data-label="Mijoz">{organization.clientsCount}</td>
								<td data-label="Holat">
									<OrganizationStatusBadge status={organization.status} />
								</td>
								<td data-label="">
									<Button
										className="crm-open-btn"
										onClick={(event) => {
											event.stopPropagation();
											onOpenOrganization(organization);
										}}
										size="small"
									>
										Ochish <RightOutlined />
									</Button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
			<div className="crm-table-foot">
				<span>Jami {organizations.length} ta tashkilot</span>
				<div className="crm-pager">
					<button type="button">‹</button>
					<button className="active" type="button">
						1
					</button>
					<button type="button">›</button>
				</div>
			</div>
		</div>
	);
}
